/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Avatar_Drag_RepositionInputs */



/**
* | output |
* | --- |
* | "Drag to reposition" |
*
* @param {Avatar_Drag_RepositionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const avatar_drag_reposition = /** @type {((inputs?: Avatar_Drag_RepositionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Avatar_Drag_RepositionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Glissez pour repositionner")
	if (locale === "es") return /** @type {LocalizedString} */ ("Arrastre para reposicionar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Arraste para reposicionar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trascina per riposizionare")
	return /** @type {LocalizedString} */ ("Drag to reposition")
});